import { gettext } from '@eventbrite/i18n';
import BicycleSA from '../static/images/bike-sa.svg';
import MamasNightmarket from '../static/images/mamas-nightmarket.svg';
import Seedtalks from '../static/images/Seed-talks.svg';
import SomethingDopeForThePeople from '../static/images/something-dope-for-the-people.svg';
import TheStartEntertainmentGroup from '../static/images/the-star-entertainment-group.svg';
import YeahBuoy from '../static/images/yeah-buoy.svg';

export const TESTIMONIALS = [
    {
        quote: gettext(
            '"For people coming to our event outside of San Francisco, nearly 70% of our attendees say they found it on Eventbrite."',
        ),
        image: MamasNightmarket,
        attribution: gettext('MAMA’s Nightmarket'),
        link: 'https://www.eventbrite.com/blog/mamas-nightmarket-growth-in-ticket-sales-eventbrite/',
        testimonialFortlds: ['com', 'uk', 'ca', 'ie'],
    },
    {
        quote: gettext(
            '"The conversion rate on Eventbrite was 20% better than other ticketing platforms...plus the automated emails generate a lot of new sales each time we post a new event."',
        ),
        image: Seedtalks,
        attribution: gettext('Seed Talks'),
        link: 'https://www.eventbrite.co.uk/blog/seed-talks-on-using-eventbrite-tools-to-drive-global-expansion/',
        testimonialFortlds: ['com', 'uk', 'ca', 'ie'],
    },
    {
        quote: gettext(
            "\"We rely on Eventbrite for its discoverability and we're gaining followers. I can't think of an event where it wouldn't make sense to be using Eventbrite's marketing tools.\"",
        ),
        image: SomethingDopeForThePeople,
        attribution: gettext('Something Dope for the People'),
        link: 'https://www.eventbrite.com/blog/something-dope-for-the-people/',
        testimonialFortlds: ['com', 'uk', 'ca', 'ie'],
    },
    {
        quote: gettext(
            '"We’ve got an event that hasn’t started marketing but we’ve already sold 250 tickets. I don’t think we would have been able to do that if it wasn’t for putting the event out there on [Eventbrite] Collection pages."',
        ),
        image: YeahBuoy,
        attribution: gettext('Yeah Buoy'),
        link: 'https://www.eventbrite.com.au/blog/yeah-buoy-sydney-boat-parties/',
        testimonialFortlds: ['au', 'nz'],
    },
    {
        quote: gettext(
            '"[Eventbrite] Collections are a super-simple way for guests to compare and decide on the spot what they’re looking for and buy tickets right away."',
        ),
        image: TheStartEntertainmentGroup,
        attribution: gettext('The Star Gold Coast'),
        link: 'https://www.eventbrite.com.au/blog/the-star-gold-coast/',
        testimonialFortlds: ['au', 'nz'],
    },
    {
        quote: gettext(
            '"It’s important that [customers] feel like they’re in a trusted environment. Most people have heard of Eventbrite ... trust and credibility is really important there."',
        ),
        image: BicycleSA,
        attribution: gettext('Bicycle SA'),
        link: 'https://www.eventbrite.com.au/blog/bicycle-sa-cycling-tours-community/',
        testimonialFortlds: ['au', 'nz'],
    },
];
